export default "__VITE_ASSET__f5I3wiNq__"